
import React, { useEffect, useState } from "react";
import socket from "../Components/socket";
import { apiRequest } from "../../apiService/allApi";

import {
  FiCalendar,
  FiUser,
  FiArrowUpRight,
  FiUsers,
} from "react-icons/fi";

import { BsTrophyFill } from "react-icons/bs";
import { CurrencyRupee } from "@mui/icons-material";

const Referralhis = () => {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [cardData, setGame] = useState([]);

  // BASE URL - retained for compatibility with existing setup
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;

  let baseUrl;

  if (nodeMode === "development") {
    baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  // GET USER PROFILE
  const role = async () => {
    try {
      socket.emit("getprofile");

      const access_token = localStorage.getItem("token");

      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const res = await apiRequest("me", "GET", null, headers);

      setUser(res.data);

      if (res?.data?.referral_code) {
        await Allgames(res.data.referral_code);
      } else {
        setGame([]);
      }
    } catch (error) {
      console.error("Error fetching referral profile:", error);
      setGame([]);
    }
  };

  // GET REFERRAL HISTORY
  const Allgames = async (id) => {
    const access_token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    setIsLoading(true);

    try {
      const res = await apiRequest(
        `referral/code/winn/${id}`,
        "GET",
        null,
        headers
      );

      setGame(Array.isArray(res?.data) ? res.data : []);
    } catch (error) {
      console.error("Error fetching referral history:", error);
      setGame([]);
    } finally {
      setIsLoading(false);
    }
  };

  // DATE FORMAT - SAME OUTPUT FORMAT
  const dateFormat = (value) => {
    const date = new Date(value);

    const newDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${newDate}, ${time}`;
  };

  useEffect(() => {
    role();
    // eslint-disable-next-line
  }, []);

  if (cardData === undefined) {
    return null;
  }

  return (


    <section className="refx-history-page">
      <div className="refx-history-list">
        {isLoading ? (
          <div className="refx-loading">
            <img
              src="/images/LandingPage_img/loader1.gif"
              alt="Loading"
            />
            <p>Loading referral history...</p>
          </div>
        ) : cardData.length === 0 ? (
          <div className="refx-empty">
            <h3>No Referral History</h3>
            <p>
              Your referral earnings will appear here when you invite friends.
            </p>
          </div>
        ) : (
          cardData.map((card, index) => {
            const earnedAmount = Number(card?.amount) || 0;
            const closingBalance = Number(card?.closing_balance);

            const formattedDate = dateFormat(card?.createdAt).split(",");

            return (
              <article
                className="refx-card"
                key={card?._id || index}
                style={{ "--refx-index": index }}
              >
                {/* LEFT: REFERRAL ARTWORK */}
                <div className="refx-artwork">
                  <div className="refx-artwork-bg" />

                  <img
                    src="/images/history-ref-reward.png"
                    alt="Referral Reward"
                    className="refx-reward-image"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />

                  <span className="refx-artwork-badge">
                    <BsTrophyFill />
                  </span>
                </div>

                {/* MIDDLE: REFERRAL DETAILS */}
                <div className="refx-details">
                  <div className="refx-detail-row">
                    <span className="refx-icon refx-user-icon">
                      <FiUsers />
                    </span>

                    <div className="refx-detail-copy">
                      <span className="refx-label">Earned From</span>

                      <strong className="refx-user-name">
                        {card?.earned_from?.Name || "Referral User"}
                      </strong>
                    </div>
                  </div>

                  <div className="refx-detail-row">
                    <span className="refx-icon refx-reward-icon">
                      <BsTrophyFill />
                    </span>

                    <div className="refx-detail-copy">
                      <span className="refx-label">Reward Type</span>

                      <strong className="refx-reward-type">
                        Referral Earning
                      </strong>
                    </div>
                  </div>
                </div>

                {/* RIGHT: AMOUNT DETAILS */}
                <div className="refx-financials">
                  <div className="refx-financial-column">
                    <div className="refx-financial-item">
                      <span className="refx-financial-icon refx-earned-icon">
                        <CurrencyRupee />
                      </span>

                      <div className="refx-financial-copy">
                        <span className="refx-label">Amount Earned</span>

                        <strong className="refx-earned-amount">
                          ₹{earnedAmount.toFixed(2)}  <div className="refx-credit-badge">
                            <FiArrowUpRight />
                            {/* <span>Credited</span> */}
                          </div>
                        </strong>

                      </div>
                    </div>


                  </div>

                  <div className="refx-financial-item">
                    <span className="refx-financial-icon refx-balance-icon">
                      <span />
                    </span>

                    <div className="refx-financial-copy">
                      <span className="refx-label">Closing Balance</span>

                      <strong className="refx-balance-amount">
                        ₹
                        {Number.isFinite(closingBalance)
                          ? closingBalance.toFixed(2)
                          : "0.00"}
                      </strong>
                    </div>
                  </div>

                  {/* <div className="refx-financial-column refx-balance-column">
                    <div className="refx-financial-item">
                      <span className="refx-financial-icon refx-balance-icon">
                        <span />
                      </span>

                      <div className="refx-financial-copy">
                        <span className="refx-label">Closing Balance</span>

                        <strong className="refx-balance-amount">
                          ₹
                          {Number.isFinite(closingBalance)
                            ? closingBalance.toFixed(2)
                            : "0.00"}
                        </strong>
                      </div>
                    </div>
                  </div> */}
                </div>

                {/* BOTTOM: DATE AND CATEGORY */}
                <div className="refx-footer">
                  <div className="refx-date">
                    <FiCalendar />

                    <span>{formattedDate[0]}</span>

                    {formattedDate[1] && (
                      <span className="refx-time">
                        @ {formattedDate[1].trim()}
                      </span>
                    )}
                  </div>

                  <span className="refx-footer-arrow">→</span>
                </div>
              </article>
            );
          })
        )}
      </div>
    </section>


  );
};

export default Referralhis;
